import type { Membership } from '@h2h/shared';
import { isLeagueActive } from '../../../data/leagues';

export function useOrderedMemberships(memberships: Membership[]) {
  return [...memberships].sort(
    (a, b) => Number(isLeagueActive(b.leagueId)) - Number(isLeagueActive(a.leagueId))
  );
}
